/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { MapCommand } from '../../map-command.class';
import { MatDialog } from '@angular/material/dialog';
import { BufferDialogComponent } from './dialog/buffer-dialog.component';
import { Select } from '@ngxs/store';
import { SelectionState } from '../../../state/selection.state';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { isEqual } from 'lodash-es';
import { BufferService } from '../buffer.service';

export class CreateBufferCommand extends MapCommand {
    @Select(SelectionState.hasSelection) hasSelection$: Observable<boolean>;

    shouldDisable$: Observable<boolean>;

    constructor() {
        super();
        this.shouldDisable$ = this.hasSelection$.pipe(
            distinctUntilChanged(isEqual),
            map(s => !s)
        );
    }

    invoke() {
        const matDialog: MatDialog = this.deps['matDialog'];
        matDialog
            .open(BufferDialogComponent)
            .afterClosed()
            .subscribe(() => this.deactivate$.next());

    }

    setDependencies(deps: { [p: string]: any }) {
        super.setDependencies(deps);
    }
}
